/**
 * Carries the provider-scoped instruction {@link InstructionStore}.
 *
 * Components register instruction blocks into this store (write-only, via
 * `useRegisterInstructions`) and read the aggregated text from it (subscribed,
 * via `useStore`). The default is a throwaway empty store, so using the
 * registration hook outside an `InstructionProvider` is a harmless no-op.
 */

import { createContext } from 'react';

import { createInstructionStore, type InstructionStore } from '#plugin-chat/lib/instructions/instructionStore.ts';

export const InstructionStoreContext = createContext<InstructionStore>(createInstructionStore());
